import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=7170ebca&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170ebca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7170ebca')) {
      api.createRecord('7170ebca', component.options)
    } else {
      api.reload('7170ebca', component.options)
    }
    module.hot.accept("./Popup.vue?vue&type=template&id=7170ebca&scoped=true", function () {
      api.rerender('7170ebca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/Popup.vue"
export default component.exports